// Import any necessary libraries or configurations here
import axios from 'axios';
import config from '../../config'

const BASE_URL = config.apiUrl // Replace with the actual base URL of your API

// Function to get the top 10 animals
export const GetTopAnimals = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/top-animals`); // Replace '/top-animals' with the actual endpoint
        return response.data; // Adjust if the API response format is different
    } catch (error) {
        console.error("Error fetching top animals:", error);
        throw error;
    }
};
